/** @hidden */
export const workbookLocale = 'spreadsheetLocale';
/**
 * Workbook locale text
 *
 * @hidden
 */
export const localeData = {
    SortOutOfRangeError: 'Select a cell or range inside the used range and try again.'
};
